import { deleted, patch, post, get } from '..';
import routes from './routes';

const UserServices = {
  createUser: async (obj) => {
    const data = await post(routes.createUser, obj);
    return data;
  },
  getUsers: async (params) => {
    const data = await get(routes.getUsers, params);
    return data;
  },
  getUserById: async (id) => {
    const data = await get(routes.getUserById + id);
    return data;
  },
  updateUser: async (id, obj) => {
    const data = await patch(routes.updateUser + id, obj);
    return data;
  },
  deleteUser: async (id) => {
    const data = await deleted(routes.deleteUser + id);
    return data;
  },
}

export default UserServices